import { jsonGet, jsonPost, jsonPatch, jsonDelete, prefix } from "../api";

export const fetchContentPlans = async (brandId) => {
  const params = brandId ? `?brandId=${brandId}` : "";
  return jsonGet(`content-plans${params}`);
};

export const fetchContentPlan = async (planId) =>
  jsonGet(`content-plans/${planId}`);

export const createContentPlan = async (planData) => {
  const { googleSearchConsoleCsv, ...jsonData } = planData;

  const plan = await jsonPost("content-plans", jsonData);

  if (googleSearchConsoleCsv) {
    await uploadGoogleSearchConsoleCsv(plan.id, googleSearchConsoleCsv);
  }

  return plan;
};

export const uploadGoogleSearchConsoleCsv = async (planId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${prefix}/content-plans/${planId}/upload-google-search-console-csv`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

export const regenerateWorkstreams = async (planId) =>
  jsonPost(`content-plans/${planId}/regenerate-workstreams`);

export const patchWorkstream = async (planId, workstreamId, data) =>
  jsonPatch(`content-plans/${planId}/workstreams/${workstreamId}`, data);

export const patchContentItem = async (
  planId,
  workstreamId,
  contentItemId,
  data
) =>
  jsonPatch(
    `content-plans/${planId}/workstreams/${workstreamId}/content-items/${contentItemId}`,
    data
  );

export const generateContentItem = async (
  planId,
  workstreamId,
  contentItemId
) =>
  jsonPost(
    `content-plans/${planId}/workstreams/${workstreamId}/content-items/${contentItemId}/generate`
  );

export const generateWorkstream = async (planId, workstreamId) =>
  jsonPost(`content-plans/${planId}/workstreams/${workstreamId}/generate`);

export const generateBrief = async (planId, workstreamId, contentItemId) =>
  jsonPost(
    `content-plans/${planId}/workstreams/${workstreamId}/content-items/${contentItemId}/generate-brief`
  );

export const deleteContentPlan = async (planId) =>
  jsonDelete(`content-plans/${planId}`);

export const deleteWorkstream = async (planId, workstreamId) =>
  jsonDelete(`content-plans/${planId}/workstreams/${workstreamId}`);

export const deleteContentIdea = async (planId, workstreamId, contentItemId) =>
  jsonDelete(
    `content-plans/${planId}/workstreams/${workstreamId}/content-items/${contentItemId}`
  );

export const publishWorkstream = async (planId, workstreamId) =>
  jsonPost(
    `content-plans/${planId}/workstreams/${workstreamId}/publish`
  );
